import { CodeEditorFormFields, FormValidationResult } from './CodeEditorForm';
import { Control, useWatch } from 'react-hook-form';
import ValidateButton from '@/components/ui/custom/buttons/ValidateButton';
import { CodeValidationResultEnum } from '@/models/CodeValidationResult';

type Props = {
  onValidate?: (data: CodeEditorFormFields) => Promise<void>;
  control: Control<CodeEditorFormFields>;
  validation?: FormValidationResult;
};

function getValidationState(validation?: FormValidationResult): boolean | null {
  if (!validation?.results?.length) return null;

  return validation.results.every(
    result => result.status?.description === CodeValidationResultEnum.ACCEPTED,
  );
}

export default function CodeEditorValidateButton({
  onValidate,
  control,
  validation,
}: Props) {
  const formData = useWatch({ control }) as CodeEditorFormFields;

  const hasTestCases =
    formData?.testCases?.some(({ expectedOutput }) => !!expectedOutput) ||
    false;

  const validationPassed = getValidationState(validation);
  const isValidating = validation?.isValidating ?? false;

  return (
    <ValidateButton
      control={control}
      onValidate={onValidate}
      validation={validationPassed}
      validationFields={['solutionCode', 'testCases']}
      condition={hasTestCases}
      isValidating={isValidating}
    />
  );
}
